import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Box, Grid } from '@mui/material';
import { isArray } from 'lodash';
import React, { useEffect } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import { VerificationAgencyClientService } from '../../../Component/Api/VerificationAgency/VerificationAgencyClient/VerificationAgencyClientService';
import AppAutoComplete from '../../../Component/Common/Components/FormValidationInputs/AppAutoComplete';
import AppCheckbox from '../../../Component/Common/Components/FormValidationInputs/AppCheckbox';
import AppSelectList from '../../../Component/Common/Components/FormValidationInputs/AppSelectList';
import AppTextInput from '../../../Component/Common/Components/FormValidationInputs/AppTextInput';
import { MDTypography } from '../../../Component/Common/Components/MDTypography';
import { companyTypeList } from '../../../Component/Common/Constants/Lists/DropdownListOptions';
import { VerificationAgencyClient } from '../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClient';
import { VerificationCompanyAtom } from '../../../State/VerificationCompany.Atom';
import { ReferredByValidationSchema } from './ReferredByValidationSchema';

export const ReferredBy = () => {

    const verificationCompany = useRecoilValue(VerificationCompanyAtom);

    const [loading, setLoading] = React.useState(false);

    const { control, handleSubmit, formState: { isSubmitting }, reset } = useForm({
        mode: 'all',
        resolver: yupResolver(ReferredByValidationSchema),
    });
    const [isConsultantUsed, setIsConsultantUsed] = React.useState(false)

    const handleDataSubmit = async (data: FieldValues) => {
        try {
            const requestData = {
                vaClientId: verificationCompany.vaClientId,
                name: data.name,
                surname: data.surname,
                email: data.email,
                isConsultantUsed: data.isConsultantUsed,
                consultantName: data.consultantName,
                consultantEmail: data.consultantEmail
            } as VerificationAgencyClient.ReferredByDto;

            const response = await VerificationAgencyClientService.UpdateReferredBy(requestData);
            toast.success("Referred By Details Saved")
        } catch (error: any) {
            console.log(error);
            if (isArray(error)) {
                let Errors: string[] = error;
                Errors.forEach((error: string) => {
                    toast.error(error);
                });
            }
        }
    }

    const getReferredBy = async () => {
        const id = verificationCompany.vaClientId;
        if (id !== 0) {
            try {
                const response = await VerificationAgencyClientService.GetReferredBy(id);

                const formData = {
                    vaClientId: verificationCompany.vaClientId,
                    name: response.data.name,
                    surname: response.data.surname,
                    email: response.data.email,
                    isConsultantUsed: response.data.isConsultantUsed,
                    consultantName: response.data.consultantName,
                    consultantEmail: response.data.consultantEmail
                };
                setIsConsultantUsed(response.data.isConsultantUsed ?? false);
                reset(formData);
            } catch (error) {
                console.log(error);
            }
        }
    }

    useEffect(() => {
        setLoading(true);
        getReferredBy();
        setLoading(false);
    }, [])


    return (
        <Box mt={2}>
            <MDTypography graphy color='primary' variant='h6' fontWeight='bold' sx={{ mb: 1 }} >
                Referred By
            </MDTypography>
            <form id='ReferredByForm' onSubmit={handleSubmit(handleDataSubmit)}>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <Box>
                            <AppTextInput control={control} name="name" label="Name" size={"small"} />
                        </Box>
                        <Box mt={2}>
                            <AppTextInput control={control} name="surname" label="Surname" size={"small"} />
                        </Box>
                        <Box mt={2}>
                            <AppTextInput control={control} name="email" label="Email" size={"small"} />
                        </Box>
                        <Box mt={2}>
                            <LoadingButton loading={isSubmitting} variant='contained' form='ReferredByForm' type="submit" color='primary'>
                                Save
                            </LoadingButton>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box>
                            <AppCheckbox
                                control={control}
                                name="isConsultantUsed"
                                label="Consultant Used"
                                disabled={false}
                                onChange={(e) => setIsConsultantUsed(e.target.checked)}
                            />
                        </Box>
                        {isConsultantUsed && (
                            <>
                                <Box mt={2}>
                                    <AppTextInput
                                        control={control}
                                        name="consultantName"
                                        label="Consultant's Name"
                                        size={"small"}
                                    />
                                </Box>
                                <Box mt={2}>
                                    <AppTextInput
                                        control={control}
                                        name="consultantEmail"
                                        label="Consultant's Email"
                                        size={"small"}
                                    />
                                </Box>
                            </>
                        )}
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}
